import { render, staticRenderFns } from "./JobDetailSummaryCard.vue?vue&type=template&id=00572def&scoped=true"
import script from "./JobDetailSummaryCard.vue?vue&type=script&lang=js"
export * from "./JobDetailSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./JobDetailSummaryCard.vue?vue&type=style&index=0&id=00572def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00572def",
  null
  
)

export default component.exports